import { InfoWindow } from "@react-google-maps/api";
function MarkerEmptyTooltip({item, closeCardHandler}) {
  const marginCounter = item?.clusterTitle > 2 ? (item?.clusterTitle - 2) * 6 : 0;
  return (
    <InfoWindow
      position={{
        lat: Number(item.lat),
        lng: Number(item.lng),
      }}
      onCloseClick={closeCardHandler}
      options={{
        disableAutoPan: false,
        maxWidth: 0,
      }}
    >
      <div style={{marginRight: (marginCounter + 18)}}>
        <div className="listing_list_style map-cluster-tooltip-container" style={{marginBottom: (marginCounter + 22)}}>
          <div className="list-inline-item">
            <div className="d-flex justify-content-center pl20 pr20 pt10 pb10">
              <span className="marker-label number_of_line_one ">
                Click to view more properties
              </span>
            </div>
          </div>
        </div>
        <div className="map-cluster-tooltipArrow" style={{marginLeft: -(marginCounter + 18), marginBottom: (marginCounter + 11)}}></div>
      </div>
    </InfoWindow>
  );
}
export default MarkerEmptyTooltip;